import script from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=7a9f8c24&lang=css"

const __exports__ = script;

export default __exports__